import Vue from 'vue'
import airbrake from '@/helpers/airbrake'

export default function registerAirbrake () {
  Vue.config.errorHandler = (err, vm, info) => {
    airbrake.notify({
      error: err,
      params: { info }
    })
  }
}



// WEBPACK FOOTER //
// ./frontend/src/plugins/airbrake.js